// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Signup from "./auth/Signup";
import Login from "./auth/Login";
import Register from "./auth/Register";
import Profile from "./pages/Profile";
import BookAppointment from "./pages/Appointment";
import History from "./pages/History";
import ClientFolder from "./pages/ClientFolder";
import AdminClientReport from "./pages/admin/ClientReports";
import AdminPatients from "./pages/admin/Patients";
import AdminAppointments from "./pages/admin/AdminAppointments";
import AdminDoctorView from "./pages/admin/AdminDoctorView";
import PrivateRouter from "./components/PrivateRouter";
import RegisteredUserRoute from "./components/RegisteredUserRoute";
import AdminRoute from "./pages/admin/AdminRoute"; // ✅ import

function App() {
  return (
    <Routes>
      <Route path="/" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<PrivateRouter><Register /></PrivateRouter>} />
      
      <Route path="/profile" element={<PrivateRouter><RegisteredUserRoute><Profile /></RegisteredUserRoute></PrivateRouter>} />
      <Route path="/history" element={<PrivateRouter><RegisteredUserRoute><History /></RegisteredUserRoute></PrivateRouter>} />
      <Route path="/appointments" element={<PrivateRouter><RegisteredUserRoute><BookAppointment /></RegisteredUserRoute></PrivateRouter>} />
      <Route path="/client-folder" element={<PrivateRouter><RegisteredUserRoute><ClientFolder /></RegisteredUserRoute></PrivateRouter>} />

      {/* ✅ Admin-only routes wrapped */}
      <Route path="/admin/client-report" element={<AdminRoute><AdminClientReport /></AdminRoute>} />
      <Route path="/admin/patients" element={<AdminRoute><AdminPatients /></AdminRoute>} />
      <Route path="/admin/appointments" element={<AdminRoute><AdminAppointments /></AdminRoute>} />
      <Route path="/admin/doctorview" element={<AdminRoute><AdminDoctorView /></AdminRoute>} />
    </Routes>
  );
}

export default App;
